<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="correctiveActionRequestForm" :refresh-key="refreshKey" :show-expand="showExpand" :set-api-data="setApiData" :show-buttons="true">
        <template v-slot:tabs>
            <v-row>
                <v-col>
                    <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                        <v-btn @click="toggleRectified(false)"> Outstanding </v-btn>
                        <v-btn @click="toggleRectified(true)"> Rectified </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'showExpand'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                correctiveActionRequestForm: () => import('../forms/CorrectiveActionRequestForm'),
                headers: [
                    { text: 'Audit', value: 'auditId', table: 'audits', form: () => import('../forms/AuditForm') },
                    { text: 'Description', value: 'description' },
                    { text: 'Severity', value: 'severity', format: this.formatEnum },
                    { text: 'Raised At', value: 'raisedAt', format: this.formatDateTime },
                    { text: 'Rectified On', value: 'rectifiedOn', format: this.formatDate },
                    { text: 'Member Comments', value: 'memberComments' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    audits: [],
                    items: []
                },
                sorting: [
                    { column: "raisedAt", direction: "descending" },
                    { column: "audit", direction: "ascending" },
                    { column: "severity", direction: "ascending" }
                ],
                itemsField: 'correctiveActionRequests',
                editPageName: 'correctiveActionRequest',
                apiMethod: 'CorrectiveActionRequests',
                claimName: 'CorrectiveActionRequests',
                formTitle: 'Corrective Action Request',
                excelTitle: 'Corrective Action Requests',
                hasEditPage: false,

                displayRectified: false,
                refreshKey: 0,
            }
        },

        methods: {
            setApiData(data) {
                this.$set(this.apiData, 'audits', data.audits);
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayRectified ? i.rectifiedOn !== null : i.rectifiedOn === null));
            },
            toggleRectified(displayRectified) {
                this.displayRectified = displayRectified;
                this.refreshKey += 1;
            }
        }
    };
</script>
